export const HOMEPAGE_ENTRY_VARIANTS = ["control", "cta"] as const;
export type HomepageEntryVariant = (typeof HOMEPAGE_ENTRY_VARIANTS)[number];

export const MAX_POSTHOG_DISTINCT_ID_LENGTH = 200;

const containsControlCharacter = (value: string) =>
  Array.from(value).some((character) => {
    const codePoint = character.codePointAt(0) ?? 0;
    return codePoint <= 31 || codePoint === 127;
  });

export const parseHomepageEntryVariant = (value: unknown): HomepageEntryVariant | undefined =>
  value === "control" || value === "cta" ? value : undefined;

export const parsePostHogDistinctId = (value: unknown): string | undefined => {
  if (
    typeof value !== "string" ||
    value.length === 0 ||
    value.length > MAX_POSTHOG_DISTINCT_ID_LENGTH ||
    value.trim() !== value ||
    containsControlCharacter(value)
  ) {
    return undefined;
  }

  return value;
};

export type HomepageEntryExperimentAttribution = {
  homepageEntryVariant: HomepageEntryVariant;
  posthogAnonymousId: string;
};

export const parseHomepageEntryExperimentAttribution = (
  value: unknown
): HomepageEntryExperimentAttribution | undefined => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return undefined;

  const metadata = value as {
    homepageEntryVariant?: unknown;
    posthogAnonymousId?: unknown;
  };
  const homepageEntryVariant = parseHomepageEntryVariant(metadata.homepageEntryVariant);
  const posthogAnonymousId = parsePostHogDistinctId(metadata.posthogAnonymousId);

  return homepageEntryVariant && posthogAnonymousId
    ? { homepageEntryVariant, posthogAnonymousId }
    : undefined;
};
